<app-header [title]="title"></app-header>
<main>
  <article>
    <img class="user-img" src="{{project.projectImageFile}}">
    <div class="leaning">
      <div class="content">
<!--        <mdb-icon fas icon="thumbs-up" size="2x" class="green-text my-2" aria-hidden="true"></mdb-icon>-->
        <h3>GRATULACJE!</h3>
        <p>Twoje zdjęcie zostało pomyślnie wczytane</p>
        <p><a href="./palettes-info/0" class="btn btn-primary">Rozpocznij</a></p>
      </div>
    </div>
  </article>
</main>
<app-footer [prev]="prev" [next]="next"></app-footer>
